import { AddressDto } from "@modules/address/addressDto"
import {
  HidableAttributeFloat,
  HidableAttributeGenderCategory,
  HidableAttributeString,
  UserProfile,
  UserProfileDraft,
} from "@modules/auth/userProfileTypes"
import { PhoneNumberWithPrefix } from "@modules/box/boxTypes"
import { BoxStaffRole, BoxStaffStatus } from "@modules/boxStaff/gateway/boxStaffDto"
import { HUImageDraftDto, HUImageDto, convertImageFromDto } from "@modules/dtos/imageDto"
import { StripeAccountStatus } from "@modules/payment/stripeTypes"
import { UserBadgeDto } from "@modules/profile/publicProfile/publicProfileDto"
import dayjs from "dayjs"
import { z } from "zod"

export const BoxesStaffMemberSchema = z.object({
  boxId: z.string(),
  boxName: z.string(),
  role: z.nativeEnum(BoxStaffRole),
  status: z.nativeEnum(BoxStaffStatus),
})

export type BoxesStaffMember = z.infer<typeof BoxesStaffMemberSchema>

export type UserProfileDto = {
  id: string
  avatar?: HUImageDto
  email: string
  firstname: string
  lastname: string
  username: string
  locale: string // todo
  inscriptionDate: string
  notificationsEnabled: boolean
  stripeAccountStatus?: StripeAccountStatus
  stripeAccountCurrency?: string
  stripeMinimumAmount?: number
  stripeMaximumAmount?: number
  biography?: string
  birthdate?: HidableAttributeString
  crossfitStartDate?: HidableAttributeString
  genderCategory?: HidableAttributeGenderCategory
  job?: HidableAttributeString
  nationality?: HidableAttributeString
  height?: HidableAttributeFloat
  weight?: HidableAttributeFloat
  address?: AddressDto
  phoneNumber?: PhoneNumberWithPrefix
  badges: UserBadgeDto[]
  emergencyInformation?: string
  boxesStaffMember: BoxesStaffMember[]
}

export type UserProfileDraftDto = {
  firstname: string
  lastname: string
  username: string
  avatar?: HUImageDraftDto
  nationality?: HidableAttributeString
  job?: HidableAttributeString
  biography?: string
  address?: AddressDto
  phoneNumber?: PhoneNumberWithPrefix
  weight?: HidableAttributeFloat
  height?: HidableAttributeFloat
  crossfitStartDate?: HidableAttributeString
  genderCategory?: HidableAttributeGenderCategory
  emergencyInformation?: string
}

export function convertUserProfileFromDto(dto: UserProfileDto): UserProfile {
  return {
    ...dto,
    inscriptionDate: dayjs(dto.inscriptionDate).toDate(),
    avatar: dto.avatar ? convertImageFromDto(dto.avatar) : undefined,
    boxesStaffMember: dto.boxesStaffMember ?? [],
  }
}

export function convertUserDraftToDto(draft: Partial<UserProfileDraft>): Partial<UserProfileDraftDto> {
  return {
    ...draft,
    avatar: draft.avatar?.localBase64
      ? {
          content: draft.avatar.localBase64,
          contentType: "base64",
        }
      : undefined,
  }
}
